import { formatInTimeZone } from "date-fns-tz";

/**
 * Format a date in full, weekday first (e.g. "Thursday, August 13, 2026").
 * If a timezone is provided, the date is read in that timezone first.
 *
 * Counterpart to `formatShortDateWithYear`, for headings where the weekday is
 * the thing the reader is checking — "is this today's list?".
 */
export const formatLongDate = (date: Date, timeZone?: string): string => {
  if (timeZone) {
    return formatInTimeZone(date, timeZone, "EEEE, MMMM d, yyyy");
  }
  return date.toLocaleDateString([], {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};
